/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InterviewOutcomeDto } from './interviewOutcomeDto';
import { InterviewStatus } from './interviewStatus';
import { TransmitStatus } from './transmitStatus';

export interface InterviewDto { 
    id?: string;
    isReceivingCountry?: boolean;
    interviewStatus?: InterviewStatus;
    physicalInterview?: boolean;
    proposedStartDate?: string;
    proposedStartTime?: string;
    proposedFinishTime?: string;
    transmitStatus?: TransmitStatus;
    address?: string;
    meetingUrl?: string;
    interviewOutcome?: InterviewOutcomeDto;
}